import { graphql } from "@opensea/graphql"
import { QuoteReceiptFragment } from "../../../../../components/QuoteReceipt/QuoteReceipt.fragment"

export const CheckoutReceiptFragment = graphql(
  `
    fragment CheckoutReceipt on Quote {
      ...QuoteReceipt
    }
  `,
  [QuoteReceiptFragment],
)
